var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 23.1559H3.48438C3.34687 23.1559 3.23438 23.2684 3.23438 23.4059V25.1559C3.23438 25.2934 3.34687 25.4059 3.48438 25.4059H27.9844C28.1219 25.4059 28.2344 25.2934 28.2344 25.1559V23.4059C28.2344 23.2684 28.1219 23.1559 27.9844 23.1559ZM4.9125 19.2434L6.15312 20.4778C6.25 20.5747 6.40937 20.5747 6.50625 20.4778L13.8406 13.1684L16.8906 16.2091C17.0785 16.3952 17.3324 16.4997 17.5969 16.4997C17.8614 16.4997 18.1152 16.3952 18.3031 16.2091L26.5594 7.98405C26.6562 7.88718 26.6562 7.7278 26.5594 7.63093L25.3188 6.39343C25.2718 6.3469 25.2083 6.3208 25.1422 6.3208C25.0761 6.3208 25.0126 6.3469 24.9656 6.39343L17.6 13.7372L14.5469 10.6966C14.359 10.5104 14.1051 10.4059 13.8406 10.4059C13.5761 10.4059 13.3223 10.5104 13.1344 10.6966L4.9125 18.8903C4.88912 18.9134 4.87056 18.9409 4.8579 18.9712C4.84523 19.0015 4.83871 19.034 4.83871 19.0669C4.83871 19.0997 4.84523 19.1322 4.8579 19.1625C4.87056 19.1929 4.88912 19.2203 4.9125 19.2434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockOutlined);
export default __webpack_public_path__ + "static/media/stock-outlined.19ebcd1e2c4f5f1e113a2f01b8050c6b.svg";
export { ForwardRef as ReactComponent };